module.exports = __webpack_public_path__ + "static/media/carousel_item_5-large.83989b8e.png";